module.exports = __webpack_public_path__ + "static/media/HeaderBackground.94fd9e5a.jpg";